export const USE_PERF = true

export const TASK_DEADLINE = 10
